'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 0 28 0.895431 28 2V20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 0L16 0V1.33333H28V0Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M28 2.66667H16V4H28V2.66667Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M16 5.33333H28V6.66667H16V5.33333Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M28 8H16V9.33333H28V8Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M0 10.6667H28V12H0V10.6667Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M28 13.3333H0V14.6667H28V13.3333Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M0 16H28V17.3333H0V16Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M28 18.6667H0V20H28V18.6667Z", fill: "#E1244A" }),
      /* @__PURE__ */ jsx("path", { d: "M0 8.88109e-06L16 0V10.6667H0V8.88109e-06Z", fill: "#0C3F8E" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.66667 9.33333C7.61178 9.33333 8.48033 9.00556 9.16485 8.45748C8.80224 8.59273 8.40976 8.66667 8 8.66667C6.15905 8.66667 4.66667 7.17428 4.66667 5.33333C4.66667 3.49238 6.15905 2 8 2C8.40975 2 8.80224 2.07393 9.16485 2.20919C8.48033 1.66111 7.61178 1.33333 6.66667 1.33333C4.45753 1.33333 2.66667 3.12419 2.66667 5.33333C2.66667 7.54247 4.45753 9.33333 6.66667 9.33333Z",
          fill: "#FFD34F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.50964 7.73592L10.6667 6.42667L11.8237 7.73592L11.5215 6.01502L13.2665 5.92672L11.7326 5.09004L12.7516 3.67069L11.141 4.34827L10.6667 2.66667L10.1923 4.34827L8.58178 3.67069L9.60075 5.09004L8.06686 5.92672L9.81186 6.01502L9.50964 7.73592Z",
          fill: "#FFD34F"
        }
      )
    ]
  }
);
const VpFlagMyAsset = forwardRef(FlagMyAsset);

export { VpFlagMyAsset as default };
